

























































import { Component, Ref, Vue } from "vue-property-decorator";
import { NotificationState } from "@/store/modules/notification";
import informationService from "@/service/informationService";
import InformationEditDialog from "@/components/organisms/information/InformationEditDialog.vue";
import InformationDeleteDialog from "@/components/organisms/information/InformationDeleteDialog.vue";
import { Information } from "@/graphql/client";
import moment from "moment";

@Component({ components: { InformationEditDialog, InformationDeleteDialog } })
export default class InformationList extends Vue {
  @Ref() readonly editDialog!: InformationEditDialog;
  @Ref() readonly deleteDialog!: InformationDeleteDialog;
  //---------------------------
  // data
  //---------------------------
  items: Information[] = [];
  headers = [
    {
      text: "公開開始日",
      value: "publicationDate",
      width: "15%",
      formatter: this.formatDateTime,
    },
    {
      text: "公開終了日",
      value: "publicationEndDate",
      width: "15%",
      formatter: this.formatDateTime,
    },
    {
      text: "タイトル",
      value: "title",
    },
    {
      text: "",
      value: "editAction",
      width: "30px",
      sortable: false,
    },
    {
      text: "",
      value: "deleteAction",
      width: "30px",
      sortable: false,
    },
  ];

  searchKeyword = "";
  loadingDataGrid = false;
  //---------------------------
  // mounted
  //---------------------------
  mounted(): void {
    this.fetchData();
  }

  //---------------------------
  // computed
  //---------------------------
  //---------------------------
  // methods
  //---------------------------
  /**
   * 日付を「YYYY/MM/DD HH:mm」形式の文字列にして返します.
   */
  public formatDateTime(value: string): string {
    return value ? moment(value).format("YYYY-MM-DD HH:00") : "";
  }

  async fetchData(): Promise<void> {
    this.loadingDataGrid = true;
    informationService.allInformations().then((items) => {
      this.items = items;
      this.loadingDataGrid = false;
    });
  }

  /**
   * お知らせ編集ダイアログ（新規追加）を表示します.
   */
  public openCreateDialog(): void {
    this.editDialog.open(informationService.defaultInformation);
  }

  /**
   * お知らせ編集ダイアログを表示します.
   */
  public openEditDialog(item: Information): void {
    this.editDialog.open(item);
  }

  /**
   * お知らせ編集ダイアログの更新成功時.
   */
  public onUpdateSuccess(updated: Information): void {
    //一覧にも反映
    const index = this.items.findIndex((el) => {
      return el.guid === updated.guid;
    });
    if (index > -1) {
      this.items.splice(index, 1);
      this.items.splice(index, 0, updated);
    }

    this.editDialog.close();
    NotificationState.notifySuccess("お知らせを更新しました！");
  }

  /**
   * お知らせ編集ダイアログの登録成功時.
   */
  public onCreateSuccess(created: Information): void {
    //一覧にも追加
    this.items.unshift(created);

    this.editDialog.close();
    NotificationState.notifySuccess("お知らせを登録しました！");
  }

  /**
   * お知らせ削除ダイアログを表示します.
   */
  public openDeleteDialog(item: Information): void {
    this.deleteDialog.open(item);
  }

  /**
   * お知らせ削除ダイアログの処理成功時.
   */
  public onDeleteSuccess(deleted: Information): void {
    //一覧からも削除
    const newItems = this.items.filter((item) => item.guid !== deleted.guid);
    this.items = newItems;

    this.deleteDialog.close();
    NotificationState.notifySuccess("お知らせを削除しました！");
  }
}
